import clsx from 'clsx'
import React, { ReactNode } from 'react'
import { Controller } from 'react-hook-form'

import s from './styles.module.scss'

import SelectField, { ISelectFieldProps } from './SelectField'
import { IControlledForm } from '../utils/controlled-form'

export type IControlledSelectFieldProps = IControlledForm &
  Pick<
    ISelectFieldProps,
    | 'menuStyle'
    | 'options'
    | 'placeholder'
    | 'onInputChange'
    | 'menuPlacement'
    | 'noOptionsMessage'
    | 'disableNoOptionsMessage'
    | 'disabled'
  > & {
    label?: string | ReactNode
    inline?: boolean
    onSelect?: (e: any) => void
    className?: string
    labelClassName?: string
    fullWidth?: boolean
    containerClassName?: string
  }

const ControlledSelectField = ({
  label,
  disabled,
  options,
  control,
  rules,
  name,
  placeholder,
  inline,
  onInputChange,
  onSelect,
  className,
  labelClassName,
  menuPlacement,
  fullWidth = false,
  containerClassName,
  noOptionsMessage,
  disableNoOptionsMessage,
  menuStyle,
}: IControlledSelectFieldProps) => {
  return (
    <div
      className={clsx(
        s.container,
        { [s.inline]: inline },
        { [s.fullWidth]: fullWidth },
        containerClassName,
      )}
    >
      {label && <p className={clsx(s.label, labelClassName)}>{label}</p>}
      <div className={clsx(s.select, className)}>
        <Controller
          render={({ field }) => {
            const value = options.find((option) => option.value === field.value)
            const onChange = (e: any) => {
              field.onChange(e.value)
              onSelect ? onSelect(e) : undefined
            }
            return (
              <div className={clsx({ [s.disabled]: disabled })}>
                <SelectField
                  placeholder={placeholder}
                  options={options}
                  value={value}
                  onChange={onChange}
                  disabled={disabled}
                  onInputChange={onInputChange}
                  menuPlacement={menuPlacement}
                  noOptionsMessage={noOptionsMessage}
                  disableNoOptionsMessage={disableNoOptionsMessage}
                  menuStyle={menuStyle}
                />
              </div>
            )
          }}
          name={name}
          control={control}
          rules={rules}
        />
      </div>
    </div>
  )
}

export default ControlledSelectField
